import { Component, OnInit } from '@angular/core';
import { FlowServiceService } from '../../Services/flow-service.service';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements OnInit {
  sections = [
    { id: 'introduction', title: '1. Introduction' },
    { id: 'what-are-cookies', title: '2. What Are Cookies' },
    { id: 'how-we-use', title: '3. How We Use Cookies' },
    { id: 'types-of-cookies', title: '4. Types of Cookies' },
    { id: 'managing-cookies', title: '5. Managing Cookies' },
    { id: 'third-party', title: '6. Third-Party Cookies' }
  ];

  constructor(private flowServiceService: FlowServiceService) { 
    window.scrollTo(0,0);
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }

  ngOnInit() {
    window.scrollTo(0,0)
    this.flowServiceService.setScrollTop();
  }
}

